<template>
  <div>
    <span v-if="codmetodopago == null"> Met. Pago Automático </span>
    <span v-if="codmetodopago == 'PPD'"> PPD </span>
    <span v-if="codmetodopago == 'PUE'"> PUE </span>
  </div>
</template>
<script>
export default {
  props: {
    codmetodopago: {
      type: String,
      default: "PUE",
    },
  },
};
</script>
